import Vue from 'vue';

export default {
    state:{
      sesion:{}
    },
    mutations: {},
    actions: { 
      Escuchar_Sesion(context){
        
      },
    },
    getters: {}
}


// WEBPACK FOOTER //
// ./src/modules/sesion.js